// extracted by mini-css-extract-plugin
module.exports = {"lastSectionPadding":"SectionLayout_lastSectionPadding__BnIci"};